module.exports = __webpack_public_path__ + "static/media/result-2.dc581112.jpg";